export default class SummaryCalculator {
  constructor (schema) {
    this.schema = schema
  }


  getSummary(records) {
    let res = this.getSummaryBasicField()
    this.schema.fields.forEach((field) => {
      if (field.type == "number") {
        res["field_" + field.order] = {
          "value": 0
        }
        records.forEach((record) => {
          res["field_" + field.order]["value"] += Number(record[field.order].data)
        })
      } else {
        res["field_" + field.order] = {
          "value": "---"
        }
      }

    });
    return this.appendOtherEmptyFields(res)
  }
  appendOtherEmptyFields(res){
    res["file"] = {
      "value": ""
    }
    res["delete" ] = {
      "value": ""
    }
    return res
  }

  getSummaryBasicField() {
    let res = {
      "id_row": {
        value: "Podsumowanie"
      },
      "created_at": {
        value: "---"
      },
      "created_by": {
        value: "---"
      }
    }
    if (this.schema.confirmation) {
      res.confirmation = {
        value: "---"
      }
    }
    return res;
  }
}
